import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-message-details',
  templateUrl: './email-message-details.component.html',
  styleUrls: ['./email-message-details.component.scss']
})
export class EmailMessageDetailsComponent implements OnInit {

  @Input() currentObject: any;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
    this.afterSubmitEvent.emit();
  }
}
